import { render, staticRenderFns } from "./trimBox.vue?vue&type=template&id=47b8fce8&"
import script from "./trimBox.vue?vue&type=script&lang=ts&"
export * from "./trimBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports